import { DOMAIN,CLIENT_CODE } from "./Client";

export const CLIENT_URL = `https://${DOMAIN}`

export const BASE_URL_API = `https://api.bumppypay.com`;
export const BASE_URL_BUMPPY2 = `https://bumppy.in`;

export const BASE_URL_AEPS = `https://bumppy.in/fingpay/v1/aeps`;
export const BASE_URL_AEPS2 = `https://bumppy.in/fingpay/v2/aeps`;

export const BASE_URL_REMITTPE_REPORT = `https://reports.remittpe.com`;

export const BASE_URL_API_TRANXT = `https://tranxtuat.${DOMAIN}/recApiFinal`
export const BASE_URL_API_TRANXT_API = `https://apitranxt.${DOMAIN}`;

export const BASE_URL_APISERVICES = `https://apiservices.${DOMAIN}`

export const BASE_URL_PAYNOW = `https://apitranxt.paynnow.com`

export const BASE_URL_AGENT = `https://agent.${DOMAIN}`;

export const BASE_URL_DOC_KYC = `https://kyc.${DOMAIN}`;
export const BASE_URL_PARTNERS_PAYNOW = `https://partners.paynnow.com`;
export const BASE_URL_REMITTPE = `https://payin.remittpe.com`;
export const BASE_URL_BUMPPY = `https://bumppy.com/apibumppypay`;

export const BASE_URL_BUMPPY_IN = `https://bumppy.in/bumppypay`;
export const BASE_URL_BUMPPY_IN_RAZORPAY = `https://bumppy.in/razorpay`;
export const BASE_BUMPPY = `https://bumppy.in`;

export const BASE_URL_BUMMPY_COM = `https://bumppy.com`;
export const BASE_URL_BUMPPY_IN_API_INTEGATION = `https://bumppy.in/api_integration`;
export const BASE_URL_BUMPPY_PAYMENT_GATEWAY = `https://bumppy.in/payment_gateway`;

export const COMPANY_CODE = CLIENT_CODE;



